module.exports = __webpack_public_path__ + "img/felhound_small.179b351c.png";